import { render, staticRenderFns } from "./ListaAutotransporte.vue?vue&type=template&id=61b24326&"
import script from "./ListaAutotransporte.vue?vue&type=script&lang=js&"
export * from "./ListaAutotransporte.vue?vue&type=script&lang=js&"
import style0 from "./ListaAutotransporte.vue?vue&type=style&index=0&id=61b24326&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports